import React, { useState, useEffect } from "react";
import Pagination from "../../components/Pagination/Pagination";
import AxiosService from "../../utils/AxiosService";
import { toast } from "react-toastify";
import AuthServiceStroage from "../../utils/auth_service/AuthServiceStorage";
import PaginationInfo from "../../components/PaginationInfo/PaginationInfo";
import UpdateManuscriptStatus from "./UpdateManuscriptStatus";
import LocalStorageService from "../../utils/auth_service/AuthServiceStorage";

const progressReportFields = [
  { label: "Total Processed:", key: "TotalProcessed" },
  { label: "Total Resolved (Unique):", key: "TotalApproved" },
  {
    label: "Total Unresolved Based on Date Invalid Flags:",
    key: "TotalDateFlagStatus",
  },
  {
    label: "Total Unresolved Based on Date Invalid Flags(Unique):",
    key: "TotalDateFlagStatusManuscripts",
  },
  {
    label: "Total Unresolved Based on Author Not Found Flags:",
    key: "TotalAuthorStatus",
  },
  {
    label: "Total Unresolved Based on Author Not Found Flags(Unique):",
    key: "TotalAuthorStatusManuscripts",
  },
  {
    label: "Total Unresolved based on LLM Title Score:",
    key: "TotalTitleScoreStatus",
  },
  {
    label: "Total Unresolved based on LLM Title Score (Unique):",
    key: "TotalTitleScoreStatusManuscripts",
  },
  {
    label: "Total Unresolved based on LLM Author Score:",
    key: "TotalAuthourScoreStatus",
  },
  {
    label: "Total Unresolved based on LLM Author Score (Unique):",
    key: "TotalAuthourScoreStatusManuscripts",
  },
  { label: "Total Unresolved (Unique):", key: "TotalUnresolved" },
];

const ExportReport = () => {
  const initialFormData = {
    TotalApproved: "",
    TotalAuthorStatus: "",
    TotalAuthorStatusManuscripts: "",
    TotalAuthourScoreStatus: "",
    TotalAuthourScoreStatusManuscripts: "",
    TotalDateFlagStatus: "",
    TotalDateFlagStatusManuscripts: "",
    TotalProcessed: "",
    TotalTitleScoreStatus: "",
    TotalTitleScoreStatusManuscripts: "",
    TotalUnresolved: "",
  };

  const [project, setProject] = useState("");
  const [projects, setProjects] = useState([]);
  const [formData, setformData] = useState(initialFormData);
  const [projectReport, setprojectReport] = useState([]);
  const [overallReport, setOverallReport] = useState({
    totalOpenAccessCountOverAll: "",
    totalOthersCountOverAll: "",
    finalOverall: "",
    totalOthersCountOverAllPercentage: "",
    totalOpenAccessCountOverAllPercentage: "",
    totalOpenAccessCountWithUs: "",
    totalOthersCountWithUs: "",
    finalWithUs: "",
    totalOpenAccessCountWithUsPercentage: "",
    totalOthersCountWithUsPercentage: "",
    totalOpenAccessCountElseWhere: "",
    totalOthersCountElseWhere: "",
    finalElseWhere: "",
    totalOpenAccessCountElseWherePercentage: "",
    totalOthersCountElseWherePercentage: "",
    rejectedManuscripts: "",
    publishedManuscripts: "",
    acceptingJournals: "",
    acceptingPublishers:"",
  });

  const localStorageService = LocalStorageService.getService();
  const apiService = new AxiosService();

  useEffect(() => {
    apiService
      .getProjectList()
      .then((response) => {
        console.log(response.data);
        setProjects(response.data.data);
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  }, []);

  const handleProjectChange = (event) => {
    const projectId = event.target.value;
    setProject(projectId);
    const selectedProject = projects.find(
      (project) => project.projectId == projectId
    );
    localStorageService.setProjectDetails(
      JSON.stringify({
        projectId: projectId,
        projectName: selectedProject ? selectedProject.projectName : "",
      })
    );

    apiService
      .getFinalExportReport(projectId)
      .then((response) => {
        console.log("----", response.data.data);
        const data = response.data.data;
        setprojectReport(data);
        setOverallReport({
          openAccess: data.totalOpenAccessCountOverAll || "",
          others: data.totalOthersCountOverAll || "",
          finalOverall: data.finalOverall || "",
          totalOpenAccessCountOverAllPercentage:
            data.totalOpenAccessCountOverAllPercentage || "",
          totalOthersCountOverAllPercentage:
            data.totalOthersCountOverAllPercentage || "",
          totalOpenAccessCountWithUs: data.totalOpenAccessCountWithUs || "",
          totalOthersCountWithUs: data.totalOthersCountWithUs || "",
          finalWithUs: data.finalWithUs || "",
          totalOpenAccessCountWithUsPercentage:
            data.totalOpenAccessCountWithUsPercentage || "",
          totalOthersCountWithUsPercentage:
            data.totalOthersCountWithUsPercentage || "",
          totalOpenAccessCountElseWhere:
            data.totalOpenAccessCountElseWhere || "",
          totalOthersCountElseWhere: data.totalOthersCountElseWhere || "",
          finalElseWhere: data.finalElseWhere || "",
          totalOpenAccessCountElseWherePercentage:
            data.totalOpenAccessCountElseWherePercentage || "",
          totalOthersCountElseWherePercentage:
            data.totalOthersCountElseWherePercentage || "",
          rejectedManuscripts: data.rejectedManuscripts || "",
          publishedManuscripts: data.publishedManuscripts || "",
          acceptingJournals: data.acceptingJournals || "",
          acceptingPublishers: data.acceptingPublishers || "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  return (
    <div className="container-fluid">
      <h3 className="text-center">Export Report</h3>

      <label htmlFor="project" className="form-label">
        Project
      </label>
      <select
        className="form-select form-select-sm"
        id="project"
        name="project"
        style={{ width: "300px" }}
        onChange={handleProjectChange}
      >
        <option selected value={""}>
          Choose Project..
        </option>
        {projects &&
          projects.map((project) => (
            <option
              value={project.projectId}
              className="bg-gray-100 hover:bg-gray-200"
              key={project.projectId}
            >
              {project.projectName}
            </option>
          ))}
      </select>

      <div className="pt-3 w-100">
        {project !== "" && (
          <>
            {/* Report Table */}
            <table className="table table-bordered w-100 mx-auto mt-4">
              <tbody>
                {progressReportFields.map((item, index) => (
                  <tr key={index}>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      {item.label}
                    </th>
                    <td className="align-middle">
                      {item.key ? projectReport[item.key] : "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Overall Section */}
            <div className="w-50 mx-auto mt-5 w-100">
              <table className="table table-bordered mt-3 text-center align-middle w-100">
                <tbody>
                  <tr>
                    <th
                      rowSpan="2"
                      className="bg-warning text-dark fs-6 fw-bold text-nowrap align-middle"
                    >
                      Overall
                    </th>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      Open Access
                    </th>
                    <td>{overallReport.openAccess}</td>
                    <td>{overallReport.openAccess}</td>
                    <td>
                      {overallReport.totalOpenAccessCountOverAllPercentage}
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      Others
                    </th>
                    <td>{overallReport.others}</td>
                    <td>{overallReport.openAccess}</td>
                    <td>{overallReport.totalOthersCountOverAllPercentage}</td>
                  </tr>
                  <tr>
                    <th
                      rowSpan="2"
                      className="bg-warning text-dark fs-6 fw-bold text-nowrap align-middle"
                    >
                      With Us
                    </th>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      Open Access
                    </th>
                    <td>{overallReport.totalOpenAccessCountWithUs}</td>
                    <td>{overallReport.finalWithUs}</td>
                    <td>
                      {overallReport.totalOpenAccessCountWithUsPercentage}
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      Others
                    </th>
                    <td>{overallReport.totalOthersCountWithUs}</td>
                    <td>{overallReport.finalWithUs}</td>
                    <td>{overallReport.totalOthersCountWithUsPercentage}</td>
                  </tr>

                  <tr>
                    <th
                      rowSpan="2"
                      className="bg-warning text-dark fs-6 fw-bold text-nowrap align-middle"
                    >
                      Else Where
                    </th>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      Open Access
                    </th>
                    <td>{overallReport.totalOpenAccessCountElseWhere}</td>
                    <td>{overallReport.finalElseWhere}</td>
                    <td>
                      {overallReport.totalOpenAccessCountElseWherePercentage}
                    </td>
                  </tr>
                  <tr>
                    <th className="bg-light text-secondary fs-6 fw-medium text-nowrap">
                      Others
                    </th>
                    <td>{overallReport.totalOthersCountElseWhere}</td>
                    <td>{overallReport.finalElseWhere}</td>
                    <td>{overallReport.totalOthersCountElseWherePercentage}</td>
                  </tr>
                </tbody>
              </table>
              <table className="table table-bordered mt-3 text-center align-middle w-100 mx-auto">
                <thead className="table-warning">
                  <tr>
                    <th>Rejected Manuscript</th>
                    <th>Published Manuscript</th>
                    <th>Accepting Journals</th>
                    <th>Accepting Publishers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{overallReport.rejectedManuscripts}</td>
                    <td>{overallReport.publishedManuscripts}</td>
                    <td>{overallReport.acceptingJournals}</td>
                    <td>{overallReport.acceptingPublishers}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ExportReport;
